import Vue from "vue";
import Router from "vue-router";
import { store } from "@/store/store";
import Setup from "@/router/setup";
import Tenant from "@/router/tenant";
import Profile from "@/router/profile";
import Item from "@/router/item";
import Order from "@/router/orders";
import Partner from "@/router/partner";
import serviceTicket from "@/router/serviceTicket";
import notificationTemplate from "@/router/notificationTemplate";
import FAQ from "@/router/faq";
import privacySetting from "@/router/privacySetting";
import survey from "@/router/survey";
import finance from "@/router/finance";
import fraudManagement from "@/router/fraudManagement";

import RolePermission from "@/views/auth/RolePermission.vue";
import Role from "@/views/auth/Role.vue";
import Permission from "@/views/auth/Permission.vue";
import features from "@/router/features";
import Attribute from "@/views/attribute/index.vue";
import { permissions as permissionConfig } from "@/auth/config";
import advertisementRouter from "@/router/advertisement";
import channelRoutes from "@/router/channel";
import paymentHistoryRouter from "@/router/paymenthistory";
import approvalRouter from "@/router/approval";
import analytics from "@/router/analytics";
import customerManagement from "@/router/customerManagement";
import applyPromo from "@/router/applyPromo";
import listOfCriteria from "@/router/bulkNotification";
import bulkPromotion from "@/router/bulkPromotion/index.js";
import approvalNotification from "@/router/approvalNotificationBulk";
import CustomerManagement from "@/router/customerManagement";
import Office from "@/router/office";
import Customer from "@/router/customer";
import BusinessPlan from "@/router/businessPlan";
import Commission from "@/router/commission";
import subscription from "@/router/subscription";
import onboardCustomer from "@/router/onboardCustomer/index";
import portfolioManagement from "@/router/portfolioManagement";
import contactUsEnquiry from "@/router/contactUsEnquiry";
import unitManagement from "@/router/unitManagement";
import feedback from "@/router/feedback";
import bookings from "@/router/bookings";
import pricingAndFareEngine from "@/router/pricingAndFareEngine";
import payment from "@/router/payment";
// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer.vue");

// Views
const Dashboard = () => import("@/views/Dashboard.vue");
// const NewDashboard = () => import("@/views/NewDashboard.vue");
const Home = () => import("@/views/home.vue");

// attribute - Components
const ViewAttribute = () => import("@/views/attribute/ViewAttribute.vue");

// catalog - Components
const CatalogDetails = () => import("@/views/catalog/CatalogDetails.vue");
const Catalog = () => import("@/views/catalog/Catalog.vue");
const Messages = () => import("@/views/messages/messages.vue");
const profile = () => import("@/views/profile/profile.vue");
const viewprofile = () => import("@/views/profile/viewprofile.vue");
const myaccount = () => import("@/views/myaccount/myaccount.vue");
// Item - Components

// Login
const Login = () => import("@/views/authentication/Login.vue");
const RecoverPassword = () =>
    import("@/views/authentication/RecoverPassword.vue");
const ChangePassword = () =>
    import("@/views/authentication/ForceChangePassword.vue");
const ConfirmMail = () => import("@/views/authentication/ConfirmMail.vue");

// Users
const Users = () => import("@/views/users/Users.vue");
const User = () => import("@/views/users/User.vue");

const SetupEmailTemplate = () =>
    import("@/views/notificationTemplate/createTemplate.vue");

Vue.use(Router);

const TYPE = "ADMIN";

export default new Router({
    mode: "hash",
    linkActiveClass: "open active",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/",
            name: "Home",
            meta: {
                requiresVisitor: true,
            },
            beforeEnter: (to, from, next) => {
                let user = JSON.parse(
                    sessionStorage.getItem("userLogin") as string,
                );
                if (
                    store.getters["auth/getUserID"] ||
                    (user && Object.keys(user).length > 0)
                ) {
                    next();
                } else if (
                    to.path.startsWith("/payment/init") ||
                    to.path.startsWith("/payment/verify") ||
                    to.name === "Payment Init"
                ) {
                    next();
                } else {
                    next("Login");
                }
            },
            component: DefaultContainer,
            children: [
                {
                    path: "home",
                    component: Home,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "dashboard",
                    name: "Dashboard",
                    component: Dashboard,
                    meta: {
                        requiresAuth: true,
                        type: TYPE,
                    },
                },
                {
                    path: "users",
                    meta: { label: "Users" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            component: Users,
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                        },
                        {
                            path: ":id",
                            meta: {
                                label: "User Details",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            name: "User",
                            component: User,
                        },
                    ],
                },
                {
                    path: "role",
                    meta: { label: "Role" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    props: {
                        auth: permissionConfig.role,
                    },
                    children: [
                        {
                            path: "",
                            meta: { label: "Role" },
                            component: Role,
                        },
                        {
                            path: "role-permission",
                            name: "RolePermission",
                            component: RolePermission,
                            meta: { label: "Role - Permission Mapping" },
                        },
                    ],
                },
                {
                    path: "permission",
                    meta: { label: "Permission" },
                    component: Permission,
                    props: {
                        auth: permissionConfig.permission,
                    },
                },
                {
                    path: "attribute",
                    meta: { label: "Attribute" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            component: ViewAttribute,
                            name: "Attribute List",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                        },
                        {
                            path: ":id",
                            meta: {
                                label: "Edit",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            name: "AttributeForm",
                            component: Attribute,
                        },
                        {
                            path: ":id",
                            meta: {
                                label: "View",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            name: "ViewAttribute",
                            component: Attribute,
                        },
                        {
                            path: "create",
                            name: "CreateAttribute",
                            meta: {
                                label: "Create Attribute",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: Attribute,
                        },
                    ],
                },
                {
                    path: "catalog",
                    meta: { label: "Catalog" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "create",
                            name: "CatalogCreate",
                            meta: {
                                label: "Create Catalog",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: CatalogDetails,
                        },
                        {
                            path: "",
                            component: Catalog,
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                        },
                        {
                            path: "view-catalog/:id",
                            name: "CatalogDetails",
                            meta: {
                                label: "Catalog Details",
                            },
                            component: CatalogDetails,
                            props: {
                                edit: true,
                            },
                        },
                    ],
                },

                {
                    path: "user",
                    meta: { label: "User Management" },

                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            name: "User mangement",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/userManagement/User.vue"),
                        },
                        {
                            path: "/user/create",
                            name: "CreateUser",
                            meta: {
                                label: "Create User",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/userManagement/CreateUser.vue"),
                        },
                        {
                            path: "/user/view/:userId",
                            name: "View User",
                            meta: {
                                label: "View User",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/userManagement/ViewUser.vue"),
                        },
                        {
                            path: "/user/Edit/:id",
                            name: "EditUser",
                            meta: {
                                label: "Edit User",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/userManagement/EditUser.vue"),
                        },
                        {
                            path: "/user/Kyc/create",
                            name: "CreateKyc",
                            meta: {
                                label: "Create Kyc",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/tenant/kycCreate.vue"),
                        },
                        {
                            path: "/user/Kyc/update",
                            name: "UpdateKyc",
                            meta: {
                                label: "Update Kyc",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/tenant/kycUpdate.vue"),
                        },
                    ],
                },
                {
                    path: "Create-Commission",
                    meta: {
                        label: "Create Commission",
                        requiresAuth: true,
                        type: TYPE,
                    },
                    component: () =>
                        import("@/views/commission/createCommissionAssign.vue"),
                },
                {
                    path: "wallet-statement",
                    meta: {
                        label: "Wallet Statement",
                        requiresAuth: true,
                        type: TYPE,
                    },
                    component: () =>
                        import("@/views/wallet/WalletStatement.vue"),
                },
                {
                    path: "delivery-preference/:id",
                    meta: {
                        label: "Delivery Preference",
                        requiresAuth: true,
                        type: TYPE,
                    },
                    name: "Delivery Preference",
                    component: () =>
                        import("@/components/MasterSetup/deliverysetup/DeliveryPreference/DeliveryPreference.vue"),
                },
                {
                    path: "promotion-preference/:id",
                    meta: {
                        label: "Promotion Preference",
                        requiresAuth: true,
                        type: TYPE,
                    },
                    name: "Promotion Preference",
                    component: () =>
                        import("@/components/MasterSetup/Coupon/promotionPreference/promotionPreference.vue"),
                },
                {
                    path: "inventory",
                    meta: { label: "Inventory" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/inventory/Inventory.vue"),
                        },
                        {
                            path: "/inventory/viewStockDetails",
                            name: "viewStockDetails",
                            meta: {
                                label: "View Stock Details",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/inventory/viewStockDetails.vue"),
                        },
                    ],
                },
                {
                    path: "offerimage",
                    meta: { label: "offerimage" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/Offerimage/offerimage.vue"),
                        },
                    ],
                },
                {
                    path: "suboffice-management",
                    meta: { label: "Stock Point Management" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/office/SubOffice.vue"),
                        },
                        {
                            path: "create",
                            name: "CreateSubOffice",
                            meta: {
                                label: "Create Stock Point",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/office/CreateSubOffice.vue"),
                        },
                        {
                            path: "view",
                            name: "ViewSubOffice",
                            meta: {
                                label: "View Stock Point",
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/office/ViewSubOffice.vue"),
                        },
                    ],
                },

                {
                    path: "manage_own_customer",
                    meta: { label: "Manage Own Customer" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/manageOwnCustomer/ManageOwnCustomer.vue"),
                        },
                        {
                            path: "/manage_own_customer/customerDetails",
                            name: "Customer-Details",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/manageOwnCustomer/customerDetails.vue"),
                        },
                        {
                            path: "/manage_own_customer/uploadHistory",
                            name: "Upload-History",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/manageOwnCustomer/uploadHistory.vue"),
                        },
                        {
                            path: "/manage_own_customer/create",
                            name: "Create New Customer",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/manageOwnCustomer/createCustomer.vue"),
                        },
                        {
                            path: "/manage_own_customer/bulkUpload",
                            name: "Bulk Upload",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/manageOwnCustomer/bulkUpload.vue"),
                        },
                        {
                            path: "/manage_own_customer/detail",
                            name: "DetailView",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/manageOwnCustomer/DetailView.vue"),
                        },
                        {
                            path: "/manage_own_customer/edit",
                            name: "editCustomer",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/manageOwnCustomer/editCustomer.vue"),
                        },
                    ],
                },

                {
                    path: "discountcoupon",
                    meta: { label: "Discount & Counts" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/discounts/Discounts.vue"),
                        },
                    ],
                },

                {
                    path: "promotions",
                    meta: { label: "Promotions" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/promotion/Promotion.vue"),
                        },
                    ],
                },
                {
                    path: "messages",
                    meta: { label: "Messages" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/messages/messages.vue"),
                        },
                    ],
                },
                {
                    path: "myaccount",
                    meta: { label: "My Account" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/myaccount/myaccount.vue"),
                        },
                        {
                            path: "changepassword",
                            meta: { label: "Chnage  Password" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },

                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/profile/changepassword.vue"),
                                },
                            ],
                        },
                        {
                            path: "walletstatement",
                            meta: { label: "Wallet Statement" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },

                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/wallet/WalletStatementPartnerOwn.vue"),
                                },
                            ],
                        },
                        {
                            path: "customer-rateing/:id",
                            meta: { label: "Customer Rateing" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },
                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/rating/index.vue"),
                                },
                            ],
                        },
                        {
                            path: "delivery-preference",
                            meta: { label: "Delivery Preference" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },
                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/components/MasterSetup/deliverysetup/DeliveryPreference/DeliveryPreference.vue"),
                                },
                            ],
                        },
                        {
                            path: "promotion-preference",
                            meta: { label: "Promotion Preference" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },
                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/components/MasterSetup/Coupon/promotionPreference/promotionPreference.vue"),
                                },
                            ],
                        },
                        {
                            path: "my-invoice",
                            meta: { label: "My Invoice" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },
                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/invoice/myPartnerInvoice.vue"),
                                },
                                {
                                    path: "details",
                                    meta: {
                                        label: "Details",
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/invoice/myInvoiceDetails.vue"),
                                },
                                {
                                    path: "unbilled",
                                    meta: {
                                        label: "Unbilled Invoice",
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/invoice/partnerUnbilledInvoice.vue"),
                                },
                            ],
                        },
                        {
                            path: "Paymentinfo",
                            meta: { label: "Payment-Info" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },
                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/paymentinfo/paymentinfo.vue"),
                                },
                            ],
                        },
                        {
                            path: "subscriptionseller",
                            meta: { label: "Subsciption" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },

                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/subscriptionseller/subscriptionseller.vue"),
                                },
                            ],
                        },
                        {
                            path: "viewprofile",
                            meta: { label: " View-profile" },
                            component: {
                                render(c) {
                                    return c("router-view");
                                },
                            },
                            children: [
                                {
                                    path: "",
                                    meta: {
                                        requiresAuth: true,
                                        type: TYPE,
                                    },
                                    component: () =>
                                        import("@/views/profile/viewprofile.vue"),
                                },
                                {
                                    path: "edit-profile",
                                    meta: { label: "Edit profile" },
                                    component: {
                                        render(c) {
                                            return c("router-view");
                                        },
                                    },

                                    children: [
                                        {
                                            path: "",
                                            meta: {
                                                requiresAuth: true,
                                                type: TYPE,
                                            },
                                            component: () =>
                                                import("@/views/profile/profile.vue"),
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "subscriptionplan",
                    meta: { label: "Pubscription-Plan" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },

                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/subscriptionplan/subscriptionplan.vue"),
                        },
                    ],
                },
                {
                    path: "faqdetails",
                    meta: { label: "faqdetails" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },

                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/faqdetails/faqdetails.vue"),
                        },
                    ],
                },
                {
                    path: "manage-team",
                    meta: { label: "Manage Team" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () => import("@/views/team/Team.vue"),
                        },
                    ],
                },
                {
                    path: "service-request",
                    meta: { label: "Service Request" },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            meta: {
                                requiresAuth: true,
                                type: TYPE,
                            },
                            component: () =>
                                import("@/views/serviceRequest/ServiceRequest.vue"),
                        },
                    ],
                },
                advertisementRouter,
                channelRoutes,
                paymentHistoryRouter,
                approvalRouter,
                analytics,
                customerManagement,
                applyPromo,
                bulkPromotion,
                listOfCriteria,
                approvalNotification,
                FAQ,
                features,
                Office,
                BusinessPlan,
                Commission,
                Setup,
                Order,
                Item,
                serviceTicket,
                Customer,
                notificationTemplate,
                Tenant,
                Profile,
                Partner,
                subscription,
                privacySetting,
                onboardCustomer,
                portfolioManagement,
                unitManagement,
                contactUsEnquiry,
                survey,
                feedback,
                bookings,
                pricingAndFareEngine,
                finance,
                fraudManagement,
                payment,
            ],
        },
        {
            path: "/login",
            name: "Login",
            component: Login,
            meta: {
                requiresVisitor: true,
            },
        },
        {
            path: "/ConfirmMail",
            name: "confirm-mail",
            component: ConfirmMail,
        },
        {
            path: "/recoverpw",
            name: "recoverpw",
            component: RecoverPassword,
        },
        {
            path: "/changepassword",
            name: "changepassword",
            component: ChangePassword,
        },
        {
            path: "/reset-password-email",
            name: "resetpasswordemail",
            component: () =>
                import("@/views/authentication/VerificationOtp.vue"),
        },
    ],
});
